import { render } from "./glass.vue?vue&type=template&id=1c5cd6d8"
import script from "./glass.vue?vue&type=script&lang=js"
export * from "./glass.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__